import isDesktop from 'helpers/isDesktop';

const mobileNavItems = [
  {
    name: 'Lobby',
    link: '/',
    iconName: 'icon-home',
    exact: true,
  },
  {
    name: 'Matches',
    link: '/matches',
    iconName: 'icon-cup',
  },
  {
    name: 'Teams',
    link: '/teams',
    iconName: 'icon-teams',
  },
  {
    name: 'Clubs',
    link: '/clubs',
    iconName: 'icon-map-check',
  },
];

const desktopNavItems = [
  ...mobileNavItems,
  {
    name: 'settingsAndPrivacy',
    link: '/user-profile',
    iconName: 'icon-burger',
  },
  {
    name: 'nationalFederation',
    link: '/nf',
    iconName: 'icon-matchpoker',
  },
];

export const navItems = isDesktop ? desktopNavItems : mobileNavItems;

export const excludedRoutes = ['/replayer'];
